import { useState } from "react";
import { aiApi } from "../lib/api";
import { useCompany } from "../masters/reference";
import { errText } from "../ui/useLoad";
import { ErrorNote, PageHead } from "../ui/bits";

const SAMPLES = ["How much cash do I have, and will it last the next three months?", "Who owes me the most, and how overdue are they?",
  "Which expenses went up the most this year?", "How did last month compare with the month before?", "What do I owe vendors, and when is it due?"];

// AI01: ask about the company's numbers (sql/246): Claude answers from a summary of the figures, never the ledger itself
export function Ask() {
  const { company } = useCompany();
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [a, setA] = useState<{ q: string; answer: string | null; reason?: string }[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const ask = (text: string) => {
    if (!text.trim() || busy) return;
    setBusy(true); setErr(null);
    aiApi.ask(company.id, text).then((r) => { setA([{ q: text, answer: r.answer, reason: r.reason }, ...a]); setQ(""); })
      .catch((e) => setErr(errText(e))).finally(() => setBusy(false));
  };
  return (
    <section className="page">
      <PageHead crumb="Reports" title="Ask about your numbers" />
      <p className="muted small">Ask in plain words. Books sends Claude a summary of this company's figures (profit and loss by month, cash, who owes and is
        owed, the cash forecast) — not the entries themselves — and Claude answers from them only. Check anything important in the reports.</p>
      <form className="fields inline" onSubmit={(e) => { e.preventDefault(); ask(q); }}>
        <label className="wide-field">Your question<input value={q} autoFocus placeholder={SAMPLES[0]} onChange={(e) => setQ(e.target.value)} /></label>
        <button className="primary" disabled={busy || !q.trim()}>{busy ? "Thinking…" : "Ask"}</button>
      </form>
      <p className="small">{SAMPLES.map((s) => <button key={s} className="link pill" onClick={() => ask(s)}>{s}</button>)}</p>
      <ErrorNote text={err} />
      {a.map((x, i) => <div key={i} className="card" style={{ padding: 16, marginTop: 12 }}>
        <p className="muted small">{x.q}</p>
        {x.answer ? <div style={{ whiteSpace: "pre-wrap" }}>{x.answer}</div> : <p className="warn">{x.reason}</p>}
      </div>)}
    </section>
  );
}
